import React from 'react';
import { BarChartIcon, LineChartIcon, PieChartIcon } from 'lucide-react';
export const ServicesSection = () => {
  return <section id="services" className="py-16 bg-slate-50" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="lg:text-center" data-id="element-198">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-199">
            Our Services
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-200">
            Investment Strategies
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-201">
            We offer a range of carefully crafted investment approaches tailored
            to different financial goals and risk profiles, with a focus on the
            Indian market.
          </p>
        </div>
        <div className="mt-16" data-id="element-202">
          <div className="space-y-12 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8" data-id="element-203">
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-204">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-205">
                <LineChartIcon size={32} data-id="element-206" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-207">
                Long-term Growth
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-208">
                Strategic investments in high-quality Indian assets with strong
                growth potential over extended time horizons.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-209">
                <li className="flex items-start" data-id="element-210">
                  <div className="flex-shrink-0" data-id="element-211">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-212">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-213"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-214">
                    Equity-focused portfolios
                  </p>
                </li>
                <li className="flex items-start" data-id="element-215">
                  <div className="flex-shrink-0" data-id="element-216">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-217">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-218"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-219">
                    Dividend growth strategies
                  </p>
                </li>
                <li className="flex items-start" data-id="element-220">
                  <div className="flex-shrink-0" data-id="element-221">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-222">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-223"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-224">
                    Technology and innovation focus
                  </p>
                </li>
              </ul>
            </div>
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-225">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-226">
                <BarChartIcon size={32} data-id="element-227" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-228">
                Balanced Portfolios
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-229">
                Diversified investment mix designed to balance growth with
                income and capital preservation across Indian markets.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-230">
                <li className="flex items-start" data-id="element-231">
                  <div className="flex-shrink-0" data-id="element-232">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-233">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-234"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-235">
                    Multi-asset allocation
                  </p>
                </li>
                <li className="flex items-start" data-id="element-236">
                  <div className="flex-shrink-0" data-id="element-237">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-238">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-239"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-240">
                    Income-generating securities
                  </p>
                </li>
                <li className="flex items-start" data-id="element-241">
                  <div className="flex-shrink-0" data-id="element-242">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-243">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-244"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-245">
                    Risk-adjusted returns
                  </p>
                </li>
              </ul>
            </div>
            <div className="relative p-8 bg-white rounded-lg shadow-sm" data-id="element-246">
              <div className="flex items-center justify-center h-16 w-16 rounded-md bg-[#D4AF37] text-white mx-auto" data-id="element-247">
                <PieChartIcon size={32} data-id="element-248" />
              </div>
              <h3 className="mt-6 text-xl font-bold text-slate-800 text-center" data-id="element-249">
                Alternative Investments
              </h3>
              <p className="mt-4 text-base text-slate-600 text-center" data-id="element-250">
                Specialized opportunities in the Indian market to enhance
                returns and diversification.
              </p>
              <ul className="mt-6 space-y-2" data-id="element-251">
                <li className="flex items-start" data-id="element-252">
                  <div className="flex-shrink-0" data-id="element-253">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-254">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-255"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-256">
                    Private equity opportunities
                  </p>
                </li>
                <li className="flex items-start" data-id="element-257">
                  <div className="flex-shrink-0" data-id="element-258">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-259">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-260"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-261">
                    Real estate investments
                  </p>
                </li>
                <li className="flex items-start" data-id="element-262">
                  <div className="flex-shrink-0" data-id="element-263">
                    <div className="h-5 w-5 rounded-full bg-[#D4AF37] flex items-center justify-center" data-id="element-264">
                      <div className="h-2 w-2 rounded-full bg-white" data-id="element-265"></div>
                    </div>
                  </div>
                  <p className="ml-3 text-sm text-slate-600" data-id="element-266">
                    Infrastructure projects
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};